import { API, graphqlOperation } from "aws-amplify";
import { configurePlusAppsync, configureGenericAppSync } from 'src/context/AuthContextUtility';


const executeQuery = async (mQry, onSuccess, onFailure, variables = undefined) => {
    await configurePlusAppsync()
    API.graphql(graphqlOperation(mQry, variables)).then(result => {
        if (onSuccess) {
            configureGenericAppSync()
            onSuccess(result)
        }
    }, function (error) {
        if (onFailure) {
            configureGenericAppSync()
            onFailure(error)
        }
    });
    await configureGenericAppSync()
}


export const submitRating = async (entityId, entityType, rating, onSuccess, onFailure) => {
    await configurePlusAppsync()
    let qry = `mutation MyMutation {
        submitRating(input: {entity_id: "${entityId}", entity_type: "${entityType}", rating: ${rating}}) {
            statusCode
            user_id
            entity_id
            entity_type
            rating
        }
    }
    `
    executeQuery(qry, onSuccess, onFailure)
}


export const deleteRating = async (entityId, entityType, onSuccess, onFailure) => {
    await configurePlusAppsync()
    let qry = `mutation MyMutation {
        deleteRating(input: {entity_id: "${entityId}", entity_type: "${entityType}"})
    }
    `
    executeQuery(qry, onSuccess, onFailure)
}


export const getUserRatings = async (entityType = "APP", onSuccess, onFailure) => {
    await configurePlusAppsync()
    let qry = `query MyQuery {
        getUserRatings(entity_type: "${entityType}") {
            entity_id
            entity_type
            rating
            updated_at
        }
    }
    `
    executeQuery(qry, onSuccess, onFailure)
}


export const getRatingAggregate = async (entityId, entityType = "APP", onSuccess, onFailure) => {
    await configurePlusAppsync()
    let qry = `query MyQuery {
        getRatingAggregate(entity_id: "${entityId}", entity_type: "${entityType}") {
            entity_type
            entity_id
            rating_sum
            rating_count
            rating_avg
            updated_at
        }
    }
    `
    executeQuery(qry, onSuccess, onFailure)
}


export const getRatingAggregatesBulk = async (entityIds, entityType = "APP", onSuccess, onFailure) => {
    await configurePlusAppsync()
    const idsArray = JSON.stringify(entityIds)
    let qry = `query MyQuery {
        getRatingAggregatesBulk(entity_ids: ${idsArray}, entity_type: "${entityType}") {
            entity_type
            entity_id
            rating_sum
            rating_count
            rating_avg
            updated_at
        }
    }
    `
    executeQuery(qry, onSuccess, onFailure)
}
